import { Capacitor } from '@capacitor/core';
import type { Content } from '@ilteducation/content-registry-types';
import { StateTree } from './use-content-store'; // eslint-disable-line import/no-cycle

type Serializer = {
  deserialize: (data: string) => StateTree<Content>;
  serialize: ({ state }: StateTree<Content>) => string;
};

type PiniaPersistOptions = {
  serializer: Serializer;
};

// eslint-disable-next-line import/no-mutable-exports
let options: PiniaPersistOptions | undefined;

if (Capacitor.isNativePlatform()) {
  options = {
    serializer: {
      deserialize: (data: string): StateTree<Content> => {
        const { serializedMaterials, isFetching } = JSON.parse(data);
        const content: Map<string, Content> = new Map(JSON.parse(serializedMaterials));
        return { state: { content, isFetching } };
      },
      serialize: ({ state }) => {
        const { content, isFetching } = state;
        const arrayOfBookEntries = Array.from(content.entries());
        const serializedMaterials = JSON.stringify(arrayOfBookEntries);
        return JSON.stringify({ isFetching, serializedMaterials });
      },
    },
  };
}

export default options;
